﻿import React from 'react';

class SavingsCard extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        let bioClassName = ''

        if(this.props.isBio && this.props.isBio === true){
            bioClassName = " is-bio"
        }
        let savingsCardIconClassNames = "savings-card__icon" + bioClassName;
       

        return (
            <div className="savings-card">

                {this.props.PreSavingsMessage &&
                    <p className="savings-card__pre-savings-message" dangerouslySetInnerHTML={{ __html: this.props.PreSavingsMessage}}/>
                }

                {this.props.KeySavingsFigure &&
                    <p className="savings-card__key-savings-figure" dangerouslySetInnerHTML={{ __html: this.props.KeySavingsFigure}}/>
                }

                {this.props.PostSavingsMessage &&
                    <p className="savings-card__post-savings-message" dangerouslySetInnerHTML={{ __html: this.props.PostSavingsMessage}}/>
                }

                {this.props.SubSavingsMessage &&
                    <p className="savings-card__sub-savings-message" dangerouslySetInnerHTML={{ __html: this.props.SubSavingsMessage}}/>
                }

                {this.props.SavingsIcon && this.props.SavingsIcon.LargeIcon &&
                    <div aria-hidden="true" className={savingsCardIconClassNames} dangerouslySetInnerHTML={{ __html: this.props.SavingsIcon.LargeIcon }} />
                }

            </div>
        )
    }
}

export default SavingsCard;